<template>
  <div id="app" data-server-rendered="true">
    <!-- 1.头部导航 -->
    <yp-navbar ref="navbar" class="no-transparent-navbar" mobileTitle="公司简介"></yp-navbar>
    <!-- 2.背景图 + 标题 -->
    <page-title-bg first-font="a" title-en="BOUT US" title-zh="走进悦朋"></page-title-bg>
    <!-- 3.面包屑导航 -->
    <div class="bread-crumbs-container hidden-xs">
      <div class="container">
        <ol class="breadcrumb">
          <li><a href="/index.html">首页</a></li>
          <li><a href="/companyProfile.html">走进悦朋</a></li>
          <li class="active">公司简介</li>
        </ol>
      </div>
    </div>
    <!-- 4.企业简介 -->
    <section class="enterprise-profile-container">
      <div class="container">
        <div class="sec-title-container">
          <div class="sec-title-zh">企业简介</div>
          <div class="sec-title-en">ENTERPRISE PROFILE</div>
        </div>
        <div class="enterprise-profile-doc-container">
          <div class="enterprise-profile-doc-content">
            <div class="doc-title">山东悦朋智能科技有限公司</div>
            <div class="doc-title-2">做有幸福感的科技企业</div>
            <div class="doc-body">
              山东悦朋智能科技有限公司，是深圳优讯龙腾科技有限公司旗下的全资子公司，位于山东省威海市；公司专注于利用大数据、云计算、物联网、人工智能等新兴技术，为传统行业数字化、智慧化提供一体化设计、建设、运营服务，推动产业转型升级，提供从顶层设计、咨询规划、平台建设、产品集成到数据运营和生态发展的端到端“一揽子”解决方案和服务。
            </div>
          </div>
          <div class="enterprise-profile-image-container">
            <img v-lazy="'/static/images/about-profile.png'" alt="" />
          </div>
        </div>
      </div>
    </section>
    <!-- 5.发展历程 -->
    <development-history></development-history>
    <!-- 6.成员企业 -->
    <member-enterprises></member-enterprises>
    <!-- 7.footer -->
    <yp-footer></yp-footer>
  </div>
</template>
<script>
import YpNavbar from '@/components/navbar.vue'
import PageTitleBg from '@/components/page-title-bg.vue'
import DevelopmentHistory from './components/development-history.vue'
import MemberEnterprises from './components/member-enterprises.vue'
import YpFooter from '@/components/footer.vue'
export default {
  components: {
    YpNavbar,
    PageTitleBg,
    DevelopmentHistory,
    MemberEnterprises,
    YpFooter,
  },
  created() {
    Media($(window).width())
    function Media(width) {
      if (width > 750) {
        refreshRem(1920)
      } else {
        refreshRem(750)
      }
    }
    // 根据设计图尺寸计算rem
    function refreshRem(designSize) {
      let html = document.documentElement
      let wW = html.clientWidth // 窗口宽度
      let rem = (wW * 100) / designSize
      document.documentElement.style.fontSize = rem + 'px'
    }

  },
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
